import { fechaHora } from '@/shared/utilidades/formato'

import estilos from './RegistrarVisita.module.css'

/**
 * LO QUE EL TÉCNICO REGISTRÓ EN LA VISITA (0256), en la ficha de la orden.
 * Las fotos ya salen en «Fotos de la visita»; aquí va lo que se dijo: qué
 * encontró y si el cliente quiere que MEGA le cotice la ejecución.
 */
export function ResultadoDeVisita({
  hechaEn,
  observacion,
  quiereCotizar,
  quien,
}: {
  hechaEn: string
  observacion: string | null
  quiereCotizar: boolean | null
  quien: string | null
}) {
  return (
    <div className={`${estilos.resultado} ${quiereCotizar ? estilos.resultadoSi : ''}`}>
      <p className={estilos.resultadoTitulo}>
        Visita hecha · {fechaHora(hechaEn)}
        {quien && ` · ${quien}`}
      </p>
      <p className={estilos.resultadoRespuesta}>
        {quiereCotizar
          ? 'El cliente QUIERE que le coticemos la ejecución.'
          : 'El cliente no quiere que le coticemos la ejecución.'}
      </p>
      {observacion && <p className={estilos.resultadoNota}>«{observacion}»</p>}
    </div>
  )
}
